export enum Domains {

    Bma = 'BMA',
    Niw = 'NIW',
    Waio = 'WAIO'

};